module.exports = __webpack_public_path__ + "static/media/ear_with_description.2d880c81.webp";